module.exports = __webpack_public_path__ + "static/img/3.3580c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/3.png
// module id = 2yhZ
// module chunks = 0